import React from "react";
import styles from "./customCard.module.css";

interface CardProps {
  icon?: React.ReactNode;
  title?: string;
  content: React.ReactNode;
  paddingInline?: string;
  shadow?: string;
}
const CustomCard: React.FC<CardProps> = ({
  icon,
  title,
  content,
  paddingInline,
  shadow,
}) => (
  <section className={styles.cardSection}>
    <div
      className={styles.card}
      style={{
        paddingInline: paddingInline ? paddingInline : "12.5rem",
        boxShadow: shadow
          ? shadow
          : "0px 2px 39px 0px rgba(180, 180, 180, 0.20) ",
      }}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{content}</div>
    </div>
  </section>
);

export default CustomCard;
